import { useCallback } from "react"
import { IProduto, IProdutoClienteAndTipoConsumo } from "../../application/models"
import { useAxiosInstances } from "../axios-instance"

export const useProdutoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getProdutosByIdUsuarioApi = useCallback(async (data: {
        IdUsuario: number
    }): Promise<IProduto[]> => {
        try {
            const result = await axiosAuthInstance.get('/produto/usuario', {
                params: {
                    idUsuario: data.IdUsuario
                }
            })
            
            if (!result.data) {
                return []
            }
            
            let produtos: IProduto[] = []
            
            if (Array.isArray(result.data.produtos)) {
                produtos = result.data.produtos
            } else if (Array.isArray(result.data)) {
                produtos = result.data
            } else if (result.data.produtos && typeof result.data.produtos === 'object') {
                produtos = [result.data.produtos]
            }
            
            
            return produtos
        }

        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        getProdutosByIdUsuarioApi
    }
}